import { Controller } from "@hotwired/stimulus";

// The "Add bed" row under a room's bed list on facility settings. Opens into
// a one-line form pre-filled with the room's next bed name; after each
// successful save it lines up the following name so beds can be entered in a
// run. The form itself is never re-rendered by the server, so focus stays put.
// The two swap through the `hidden` class rather than the attribute: the
// toggle is a flex row, and Tailwind's `flex` outranks the `[hidden]` rule.
//
//   <div data-controller="inline-bed-form" data-inline-bed-form-next-name-value="A-04">
//     <button data-inline-bed-form-target="toggle" data-action="inline-bed-form#open">
//       Add bed <span data-inline-bed-form-target="nextName">A-04</span>
//     </button>
//     <form class="hidden" data-inline-bed-form-target="form"
//           data-action="turbo:submit-end->inline-bed-form#submitted keydown.esc->inline-bed-form#close">
//       <input data-inline-bed-form-target="name">
//     </form>
//   </div>
export default class extends Controller<HTMLElement> {
  static targets = ["toggle", "form", "name", "nextName"];
  static values = { nextName: String };

  declare readonly toggleTarget: HTMLElement;
  declare readonly formTarget: HTMLFormElement;
  declare readonly nameTarget: HTMLInputElement;
  declare readonly nextNameTarget: HTMLElement;
  declare nextNameValue: string;

  open() {
    this.toggleTarget.classList.add("hidden");
    this.formTarget.classList.remove("hidden");
    this.nameTarget.value = this.nextNameValue;
    this.nameTarget.focus();
    this.nameTarget.select();
  }

  close() {
    this.formTarget.classList.add("hidden");
    this.toggleTarget.classList.remove("hidden");
  }

  submitted(event: CustomEvent<{ success: boolean }>) {
    if (!event.detail.success) return;

    this.nextNameValue = this.advance(this.nameTarget.value);
    this.nextNameTarget.textContent = this.nextNameValue;
    this.nameTarget.value = this.nextNameValue;
    this.nameTarget.select();
  }

  // "A-04" -> "A-05", keeping the zero padding; a name with no trailing
  // number has nothing to continue from.
  private advance(name: string): string {
    const match = name.trim().match(/^(.*?)(\d+)$/);
    if (!match) return "";

    const [, stem, digits] = match;
    return stem + String(Number(digits) + 1).padStart(digits.length, "0");
  }
}
